<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container avance">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-12">
              <div class="row pt-2 pt-lg-0 white">
                <div class="col-12 pb-3 fXG">
                  Hola
                  <span class="naranja">{{this.$store.state.user.nombre}}</span>,
                </div>
                <div class="col-12 pb-3 fG">
                  en esta sección podrás descargar tu
                  <span class="naranja">certificado</span> de
                  <span class="bold">Maestro Parrillero</span>.
                </div>
              </div>

              <div class="row pt-2 white">
                <div
                  class="col-6 pb-3 d-flex align-items-center"
                  v-for="(slide, i) in cursos"
                  :index="i"
                  v-bind:key="i"
                >
                  <img
                    class="flama"
                    src="../../assets/imgs/cursos/flama_off.png"
                    v-if="slide.completo == '0'"
                  />
                  <img
                    class="flama"
                    src="../../assets/imgs/cursos/flama_on.png"
                    v-if="slide.completo == '1'"
                  />

                  <div>
                    <div class="naranja">{{slide.clase}}</div>
                    <div>{{slide.titulo}}</div>
                  </div>
                </div>
              </div>

              <div class="row pb-5 objetivo">
                <div class="col-12 col-lg-8 offset-lg-2">
                  <div class="row">
                    <div class="col-12 pt-4">
                      <div class="row">
                        <div class="col-12 col-lg-12 text-center pb-3">
                          <a
                            v-if="mdlpCompleto == true"
                            target="_blank"
                            :href="this.$store.state.baseurl + 'certificado.php?e='+this.$store.state.user.email"
                            class="btn btnsup"
                          >Descargar Certificado</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Footer from "../../Components/Footer.vue";
import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);
import { Carousel3d, Slide } from "vue-carousel-3d";

//Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      index: 0,
      mdlpCompleto: false
    };
  },
  mounted: function() {
    // Opción múltiple
    // relacionar columnas
    // eliminar el incorrecto
    // poner en orden varios elementos

    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.$store.state.user = JSON.parse(
      localStorage.getItem("useracademiadigital")
    );
    AOS.init();

    this.consulta();
  },
  components: {
    "header-mx": Header,
    "footer-mx":Footer
  },
  methods: {
    consulta() {
      console.log("submit");
      var vm = this;

      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        email: this.$store.state.user.email
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "avance.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //guardado, algo más?
              this.cursos = res.cursos;

              var cont = 0;
              this.cursos.forEach( elem => {
                if(elem.completo == true){
                  cont ++;
                }
              });
              if(cont == 7){
                this.mdlpCompleto = true;
              }

            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }

          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        matricula: this.matricula,
        password: this.password
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "home/login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //localStorage.setItem('user', res.user);
              this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              vm.$store.state.user = this.$cookie.get("useracademiadigital");
              this.$router.push(res.url);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

